<ng-container *ngIf="staticContent" id="latest-updates">
  <div class="min-h-screen flex flex-col">
    <app-navbar [navBarData]="staticContent.headerData"></app-navbar>
    <section id="update-section" class="flex-grow">
      <div class="mt-20">
        <div class="flex flex-wrap">
          <div class="w-full">
            <h3 class="my-5 text-center font-bold">{{karmayogiCorner?.title | translate}}</h3>
            <ol id="contentarea" class="m-2 pt-3 list-decimal list-inside">
              <ng-container *ngFor="let updates of latestUpdatesLinks">
                <li>
                  <a [href]="updates?.updateUrl" target="_blank" class="dataLink">{{updates.updateTitle}}</a>
                </li>
              </ng-container>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <div class="footer footer-nav mt-auto">
      <app-footer-nav [navFooterDetails]="staticContent.navFooterDetails"></app-footer-nav>
    </div>
  </div>
</ng-container>